var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalpayble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Total_payble",
    "data-name": "Total payble",
    d: "M35.12,13.733a17.875,17.875,0,0,0,5.568-6.97,4.871,4.871,0,0,0-.507-4.54A5.043,5.043,0,0,0,36,0H21a5.049,5.049,0,0,0-4.18,2.222,4.87,4.87,0,0,0-.51,4.535,17.853,17.853,0,0,0,5.57,6.972C10.238,18.053,1,32.9,1,45A15.015,15.015,0,0,0,16,60H41A15.015,15.015,0,0,0,56,45C56,32.9,46.763,18.052,35.12,13.733Zm.92-8.82c-1.288,3.24-5.235,5.982-7.545,7.275C26.188,10.9,22.258,8.188,21,5ZM41,55H16A10.01,10.01,0,0,1,6,45C6,31.892,17.775,17.5,28.5,17.5S51,31.892,51,45A10.01,10.01,0,0,1,41,55Z",
    transform: "translate(-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalpayble);
export default __webpack_public_path__ + "static/media/Total payble.a304c7fd7a80caff2b9aab25e5d97703.svg";
export { ForwardRef as ReactComponent };